import React from "react";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const StyledBadge = styled(Badge)({
  "& .MuiBadge-badge": {
    color: "#ffffff",
    backgroundColor: "#ff4040",
  },
});

const Bucket = ({countLotteryPickup, startTimer}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const handleChange = async () => {
    startTimer()
  }


  return (
    <button className={`border-2 rounded-lg bg-[#f8eede] border-[#b3853e] text-[#b3853e] fixed -right-20 bottom-20 z-50 px-1 py-2 w-20 mr-0.5 shadow-lg ${countLotteryPickup?.length && `animate-bucket`}`} style={{animationFillMode: 'forwards'}} onClick={() => handleChange() }>
      <StyledBadge badgeContent={countLotteryPickup?.length} max={99} color="primary">
        <StorefrontRoundedIcon fontSize="medium" />
      </StyledBadge>
      <p>สั่งซื้อ</p>
    </button>
  );
};

export default Bucket;
